module.exports = __webpack_public_path__ + "img/badge-fastest-lead-pickup-keyvue-pink.a9bdbcea.png";